import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UUID } from "angular2-uuid";
import { BehaviorService } from './_services/behavior.service';


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public propConfs$: any;
  public langs: string[] = ['en'];
  public readonly relativeUrl: string = `${location.protocol}//${location.host}`;

  /*---------- PROJECT VARIABLES ----------*/
  public readonly serviceId: number = undefined;
  public readonly operatorId: number = undefined;
  public readonly prefix: string = null;
  public readonly productId: number = undefined;

  public readonly ableThemeChange: boolean = true;

  public readonly loginFlow = {
    haveHttps: true,
    pinConfirmation: true,
    queryToken: null,
    headers: null,
    rTime: true,
    decriptHeaders: false,
    decriptQueryToken: true
  }

  public readonly event = {
    timweBi: !~['localhost'].indexOf(location.hostname),
    analyticsId: null
  }

  public firebaseConf = {
    apiKey: "AIzaSyC1cdjhL7pgXdtmhcV61pSgYTUCwpwIP-U",
    authDomain: "upar-301711.firebaseapp.com",
    projectId: "upar-301711",
    storageBucket: "upar-301711.appspot.com",
    messagingSenderId: "298861866748",
    // appId: "1:298861866748:web:20f7bbf1a7a091a858b179",
    // measurementId: "G-1VK9571ZR8"
  }
  /*---------- PROJECT VARIABLES ----------*/

  constructor(private beh: BehaviorService) {
    this.beh.propConfs.subscribe(props => { this.propConfs$ = props });
    this.beh.portalLangs.subscribe(l => { this.langs = l });
  }

  public getQueryParams(): any {
    let result: any = {};
    let _params = new URLSearchParams(location.search) as any;
    for (let param of _params) { result[param[0]] = param[1] }
    return result;
  }

  public callHeaders(useJwt: boolean = true) {
    let user = JSON.parse(localStorage.u || '{}');
    let httpOptions = new HttpHeaders().set('Content-Type', 'application/json');
    useJwt && user.j && (httpOptions = httpOptions.set('jwt', user.j));
    return httpOptions;
  }

  public hostName() {
    let params = new URLSearchParams(location.search);
    if (!!~['localhost', 'qua.upar.gg', 'staging.upar.gg'].indexOf(location.hostname)) {
      if (params.has('portal')) {
        localStorage.p = params.get('portal');
        return params.get('portal');
      } else if (!!localStorage.p) {
        return localStorage.p;
      } else {
        return location.hostname;
      }
    } else {
      return location.hostname;
    }
  }

  /* public daisLeft(date) {
    return +moment.duration(moment(date).startOf('day').diff(moment())).asDays().toFixed();
  } */

  public entitysToPlain(entitys: any[]): any[] {
    for (let entity of entitys) {
      if (entity?.props) {
        for (let prop of entity.props) {
          if (prop.propertyDef?.searchKey.includes('_ref')) {
            if (!!prop.referencedEntity) {
              let contentInfo = {
                'id': prop.id,
                'value': prop.value,
                'entityId': prop.entityId,
                'propDefId': prop.propDefId,
                // 'sortField': prop.referencedEntity.sortField
              }

              for (let cont of prop.referencedEntity.props) {
                if (cont.propertyDef?.searchKey.includes('_ref')) {
                  if (!!cont.referencedEntity) {
                    let contentInfo2 = {
                      'id': cont.id,
                      'value': cont.value,
                      'entityId': cont.entityId,
                      'propDefId': cont.propDefId,
                      // 'sortField': cont.referencedEntity.sortField
                    }

                    for (let incont of cont.referencedEntity.props) {
                      contentInfo2[incont.propertyDef.searchKey] = incont.value;
                    }
                    !!contentInfo[cont.propertyDef.searchKey] ? contentInfo[cont.propertyDef.searchKey].push(contentInfo2) : contentInfo[cont.propertyDef.searchKey] = [contentInfo2];
                  } else {
                    !!contentInfo[cont.propertyDef.searchKey] ? contentInfo[cont.propertyDef.searchKey].push(cont) : contentInfo[cont.propertyDef.searchKey] = [cont];
                  }
                } else {
                  // !contentInfo[cont.propertyDef.searchKey] && (contentInfo[cont.propertyDef.searchKey] = cont.value);/*-- cd --*/
                  contentInfo[cont.propertyDef?.searchKey] = cont.value;
                }
              }
              !!entity[prop.propertyDef.searchKey] ? entity[prop.propertyDef.searchKey].push(contentInfo) : entity[prop.propertyDef.searchKey] = [contentInfo];
            } else {
              !!entity[prop.propertyDef.searchKey] ? entity[prop.propertyDef.searchKey].push(prop) : entity[prop.propertyDef.searchKey] = [prop];
            }
          } else {
            // !entity[prop.propertyDef.searchKey] && (entity[prop.propertyDef.searchKey] = prop.value);/*-- cd --*/
            entity[prop.propertyDef?.searchKey] = prop.value;
          }
        }
        delete entity.props;
      }
    }
    return entitys;
  }

  public copyCode(toCopy, icon: boolean = false) {
    let elememt = !icon ? toCopy.target || toCopy : toCopy.target.previousElementSibling;
    elememt.select();
    elememt.setSelectionRange(0, 999);
    document.execCommand('copy');
    // navigator.clipboard.writeText(elememt.value)
    /* elememt.classList.add('selection');
    setTimeout(() => { elememt.classList.remove('selection') }, 4000); */
    this.beh.toast.next({ type: 'info', description: 'global.textCopied', time: 2 });
  }

  public toggleSecret(elm: any, forceShow: boolean = false) {
    let inp: HTMLInputElement = elm ? elm.target.previousElementSibling : document.querySelector('.user-pass');
    let passHided: boolean = forceShow || inp.getAttribute('type') == 'password';

    inp?.setAttribute('type', passHided ? 'text' : 'password');
  }

  public bodyScroll(open) {
    open ? document.body.classList.add('modal-open') : document.body.classList.remove('modal-open');
  }

  public yearsAgo(years: number): string {
    let date = new Date();
    return `${date.getFullYear() - years}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
  }

  /* public setCookies() {
    let expireDate = new Date(`${new Date().getFullYear() + 2}-${new Date().getMonth() + 1}-${new Date().getDay()}`);
    document.cookie = `_up.acpt=; expires=${expireDate}`;
  }

  public getCookies() {
    let ck: any = {};
    for (let c of document.cookie.split('; ')) { ck[c.split('=')[0]] = c.split('=')[1] }
    return ck;
  } */

  public generateDeviceId() {
    let user = JSON.parse(localStorage.u || '{}');

    if (user.d) {
      return user.d;
    } else {
      user.d = UUID.UUID();
      window.localStorage.u = JSON.stringify(user);
      return user.d;
    }
  }

  public generateSessionId() {
    let userSession = JSON.parse(sessionStorage.u || '{}');

    if (userSession.s) {
      return userSession.s;
    } else {
      userSession.s = UUID.UUID();
      window.sessionStorage.u = JSON.stringify(userSession);
      return userSession.s;
    }
  }
}
